export enum EMessageContentType {
  Deleted = 'deleted',
  Offer = 'offer',
  ImageAsDocument = 'imagesAsDocument',
  Document = 'document',
  ImageWithText = 'imagesWithText',
  Image = 'image',
  Text = 'text',
}
